import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {injectIntl} from 'react-intl';
import {connect} from 'react-redux';
import {browserHistory} from 'react-router';

import {PushEvent} from '../utils/googleTagManager';
import {onSocialClick} from '../utils/socials';

class SocialButton extends Component {
  constructor(props) {
    super(props);

    this.handleBackClick = this.handleBackClick.bind(this);
    this.handleButtonClick = this.handleButtonClick.bind(this);
  }

  handleButtonClick() {
    onSocialClick({
      ...this.props,
      externalWindow: this.props.xl.externalWindow
    });
  }

  handleBackClick() {
    const {pathname, search} = this.props.url;
    PushEvent('Social auth', {social: 'BackToEmailLogin'});
    browserHistory.push(`${pathname}${search}`);
  }

  render() {
    const {intl, role, flat, label, name} = this.props;
    const flatClass = flat ? ' button-flat' : '';
    const roleClass = role ? ` social-button--${role}` : '';
    const intlLabel = intl.messages[`socials.${label}`] || label;
    const children = (
      <div className="button-content">
        <span className="icon" />
        <span className="label">
          {flat ? intlLabel : intl.formatMessage({id: 'socials.sign-in-with'}, {name: intlLabel})}
        </span>
      </div>
    );
    const className = `form-button with-icon button-${name}${flatClass}${roleClass}`;

    if (label !== 'email') {
      return (
        <button type="button" className={className} onClick={this.handleButtonClick}>
          {children}
        </button>
      );
    }

    return (
      <button type="button" className={className} onClick={this.handleBackClick}>
        {children}
      </button>
    );
  }
}

SocialButton.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  url: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  flat: PropTypes.bool,
  intl: PropTypes.object,
  role: PropTypes.string,
  xl: PropTypes.object.isRequired
};

export default injectIntl(connect(state => state)(SocialButton));



// WEBPACK FOOTER //
// ./components/SocialButton.jsx